import * as types from '../const/action.types';

export function setLang(lang) {
    return {
        type: types.SET_LANG,
        lang,
    };
}



// WEBPACK FOOTER //
// ./src/actions/language.actions.js